import axios from "@/libs/api.request";
// 获取列表
export const getB2BDetails = params => {
  return axios.request({
    url: "/finance/hq/dbl/outbound/index",
    method: "get",
    params
  });
};

// export const getB2BDetails = data => {
//   return axios.request({
//     url: "/finance/hq/dbl/outbound/list",
//     method: "post",
//     data
//   });
// };

export const exportB2BDetails = params => {
  return axios.request({
    url: "/finance/hq/dbl/outbound/export",
    method: "get",
    params
  });
};

export const createB2Bbill = data => {
  return axios.request({
    url: "/finance/hq/dbl/outbound/create",
    method: "post",
    data
  });
};

// 获取优选抬头
export const getB2Bbill = params => {
  return axios.request({
    url: "/common/contractParam",
    method: "get",
    params
  });
};

// 同步数据
export const syncB2Bbill = params => {
  return axios.request({
    url: "/finance/hq/dbl/outbound/sync",
    method: "get",
    params
  });
};

// 获取拆包信息
export const getB2BbillSplit = params => {
  return axios.request({
    url: `/finance/hq/dbl/outbound/package/${params.airway_number}`,
    method: "get",
    params
  });
};

// 获取拆包信息
export const getB2BbillSplitDetail = params => {
  return axios.request({
    url: `/finance/hq/dbl/outbound/packing`,
    method: "get",
    params
  });
};

export const getRate = id => {
  return axios.request({
    url: `/finance/hq/dbl/outbound/rate/`+id,
    method: "get",
  });
};

export const saveRate = data => {
  return axios.request({
    url: "/finance/hq/dbl/outbound/saveRate/"+data.id,
    method: "post",
		data
  });
};